@if (this.activeComponent && showPage()) {
<div>
  <div class="ot-row">
    <div class="otsc-prop-header">
      <h1 class="otsc-prop-header-text" i18n>Create a Logs Package for {{activeProduct.name}}</h1>
      <div class="ot-btn-group otsc-prop-header-btn">
        <button id="start-button" role="button" class="ot-btn ot-btn--is-primary" (click)="validateTasks()"
          [disabled]="started || !isReadyToStart()" i18n>Start</button>
        <button id="cancel-button" role="button" class="ot-btn ot-btn--is-secondary" (click)="back()"
          [disabled]="started" i18n>Back</button>
      </div>
    </div>
  </div>
  <div class="ot-pt-1 ot-pb-1 ot-pl-1 ot-pr-1" style="height: calc(100vh - 200px);">
    <ng-scrollbar>
      <div class="ot-row">
        <p style="font-size: 16px;margin-bottom: 0;" i18n>
          A Logs Package assembles the log files that you select for provision to OpenText Customer Support.
        </p>
      </div>
      <div class="ot-row">
        <p style="font-size: 16px;margin-bottom: 0;" i18n>
          Creating a Logs Package may require a significant amount of disk space. You currently have {{freeDiskSpace}}
          of disk space on your System Center Manager host computer.
        </p>
      </div>
      <div class="ot-row ot-pb-1">
        <p style="font-size: 16px;margin-bottom: 0;font-weight: bold;">
          {{supportedProductLogs.desc}}
        </p>
      </div>
      <form [formGroup]="packageForm" name="package-name-form">
        <fieldset [disabled]="started">
          <div class="ot-row">
            <div class="ot-col ot-row__column ot-row__column--is-25">
              <div class="ot-form-control"
                [ngClass]="{'ot-form-control--is-invalid' : (packageNameCtrl.touched && packageNameCtrl.invalid)}">
                <label class="ot-form-control__label" for="package-name" i18n>
                  Package name
                </label>
                <div class="ot-form-control__input-group">
                  <input id="package-name" formControlName="packageNameCtrl" placeholder="Enter a package name"
                    type="text" maxlength="70" class="ot-input ot-input--is-expanded">
                  @if (packageNameCtrl.touched && packageNameCtrl.invalid) {
                  <span class="ot-form-control__error-icon"></span>
                  }
                </div>
                @if (packageNameCtrl.touched && packageNameCtrl.invalid && packageNameCtrl.errors.required) {
                <p id="packageNameRequiredMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                  Package name is required.
                </p>
                }
                @if (packageNameCtrl.errors?.pattern && packageNameCtrl.dirty) {
                <p id="packageNameCharacterMsg" class="ot-form-control__error-text" i18n autocomplete="off">
                  Invalid characters.
                </p>
                }
              </div>
            </div>
          </div>
          <div class="ot-row">
            <div class="ot-row">
              <div class="ot-col ot-row__column ot-row__column--is-90">
                <div id="supportedLogsList" class="ot-form-control">
                  <label class="ot-form-control__label" i18n>Supported Logs</label>
                  <div class="ot-checkbox-group" style="padding-left:5px">
                    @if (supportedProductLogs.logs.length >= 9) {
                    <label class="ot-checkbox">
                      <app-checkbox [identifier]="'selectAllLogTypes'" [(ngModel)]="isSelectAllChecked" i18n-label
                        [label]="selectAllLabel" i18n-arialabel [arialabel]="selectAllLabel"
                        (change)="toggleSelectAllSupportedLogs()" [ngModelOptions]="{standalone: true}">
                      </app-checkbox>
                    </label>
                    }
                    <div [class]="logColClass">
                      @for (log of supportedProductLogs.logs; track log) {
                      <app-checkbox [identifier]="log.id" [(ngModel)]="log.isSelected" i18n-label [label]="log.name"
                        i18n-arialabel [arialabel]="log.name" (change)="onSupportedLogsChanged()"
                        [ngModelOptions]="{standalone: true}">
                      </app-checkbox>
                      }
                    </div>
                  </div>
                  <p class="ot-form-control__info-text">
                    {{supportedProductLogs.info}}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </form>
      <app-datatable [identifier]="'logs-pkg-instance-table'" [title]="agentTableTitle" [cols]="agentCols"
        [rows]="agentRows" [showcheckboxes]="true" [pagination]="false" [disableSelectAllCheckbox]="started"
        [scroll]="false" [isSortable]="false" (actionmenuevent)="actionMenuClicked($event)"
        (rowclickevent)="rowClick($event)" [recountSelectedRow]="recountSelectedRow"></app-datatable>
    </ng-scrollbar>
  </div>
</div>
} @else {
<div class="ot-progress ot-progress--is-bouncer ot-progress--is-bouncer-big ot-progress--is-bouncer-has-text">
  <div class="ot-progress__outer">
    <div class="ot-progress__meter"></div>
  </div>
  @if (isLoading && !isManifestUpdating && !isAgentManifestUpdating) {
  <div class="ot-progress__text" i18n>Loading...</div>
  }
  @if (isManifestUpdating) {
  <div class="ot-progress__text" i18n>Please wait while the manifest is updated...</div>
  }
  @if (isAgentManifestUpdating) {
  <div class="ot-progress__text" i18n>Please wait while the Agent manifest is updated...</div>
  }
</div>
}